import React from "react";
import BuildTogetherSection from "./components/build-together";
import BecomePartnerForm from "./components/become-partner-form";
import WhyChooseUs from "./components/why-choose-us";
import Advantages from "./components/advantages";
import "./become-provider.scss";

function BecomeProvider() {
  return (
    <>
      <BuildTogetherSection />
      <BecomePartnerForm />
      <WhyChooseUs />
      <Advantages />
    </>
  );
}

export default BecomeProvider;
